import {useEffect, useState} from "react"
import {useSearchParams} from "react-router-dom"

import {NotificationOfAssignmentAcknowledgementFailure} from "./NotificationOfAssignmentAcknowledgementFailure"

import {LoadingPage} from "@indebted/components/Loading"
import {notificationOfAssignmentAcknowledgementAPI} from "@indebted/api"

function NotificationOfAssignmentAcknowledgement() {
	const [Component, setComponent] = useState(<LoadingPage />)

	const [searchParams] = useSearchParams()
	const ids = searchParams.get("ids")
	const customerId = searchParams.get("customer-id")

	useEffect(() => {
		notificationOfAssignmentAcknowledgementAPI
			.acknowledge({ids, customerId})
			.then(({RedirectURL}) => {
				const timeToCatchup = 1000
				setTimeout(() => (window.location = RedirectURL), timeToCatchup)
			})
			.catch((error) => {
				setComponent(<NotificationOfAssignmentAcknowledgementFailure {...error} />)
			})
	}, [ids, customerId])

	return Component
}

export {NotificationOfAssignmentAcknowledgement}
